<div class="dialog-container">
    <div class="title" mat-dialog-title>
        {{data.title | translate}}
        <img class="close-icon" (click)="close()" src="assets/close-icon.png" />
    </div>
    <mat-divider></mat-divider>

    <div class="my-3">
        <mat-dialog-content>
            <span class="description">
                {{data.description | translate}}
            </span>
        </mat-dialog-content>
    </div>

    <mat-divider></mat-divider>
    <div class="float-end">
        <mat-dialog-actions>
            <button class="mat-raised-button mat-primary ms-3" [ngStyle]="{'background-color': '#007cb0'}"  (click)="close()">{{data.primarybutton | translate}}</button>
        </mat-dialog-actions>
    </div>
</div>